module.exports = __webpack_public_path__ + "static/media/10.c922837c.jpg";